<template>

    <el-card class="x-card box-card" >

        <div slot="header" class="clearfix">
            <span>{{title}}</span>ooooo
        </div>

        <slot></slot>    
    </el-card>
</template>

<script>
export default {
    name: 'XCard',
    props: ['title'],
    data(){
        return {}
    }
}
</script>
